export default "__VITE_ASSET__a08e1315__"